import { render, staticRenderFns } from "./recolumn-edit-bank.vue?vue&type=template&id=62a093e0&"
import script from "./recolumn-edit-bank.vue?vue&type=script&lang=js&"
export * from "./recolumn-edit-bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports